<template>
    <div>
        <LocaleSwitcher
            v-for="locale in supportedLocales"
            :key="locale"
            :size="props.size"
            :locale="locale"
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import LocaleSwitcher from './LocaleSwitcher.vue'
import { useI18nAddon } from '@/i18n/i18n'

interface LocaleSwitcherListProps {
    size?: 'm' | 'l'
}

const props = withDefaults(defineProps<LocaleSwitcherListProps>(), {
    size: 'm',
})

const i18nAddon = useI18nAddon()

const supportedLocales = computed(() => i18nAddon.getSupportedLocales())
</script>
